import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import RowClick from '../../../common/RowClick';
import { cellNegtiveRed } from '../../../common/table/CustomCellTable';
import Table from '../../../common/table/Table';
import TextBlink from '../../../common/table/TextBlink';
import { getColorPrice } from '../../../helpers/Color';
import { getDataFollowKeyByDot } from '../../../helpers/Common';
import {
  formatPercent,
  formatPrice,
  formatTextFloat,
  formatValueBillion,
} from '../../../helpers/Text';
import CellHover from '../../../market/watchlist/summary/CellHover';
import { getSortStateParams } from '../helper';
import {
  REDUCER_NAME,
  loadMoreData,
  changeSortState,
  getScreenerData,
} from '../reducer';
import TradingViewUrl from '../../../common/TradingViewUrl';
import Const from './Const';

class TableFinancial extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 30,
    };
    this.tableRef = React.createRef();
  }

  getDataFromRedux = state =>
    state[REDUCER_NAME].listObjectScreenerDataByTicker;

  getClassName = (item, listColumn) => {
    return getColorPrice(
      getDataFollowKeyByDot(item, listColumn.PRICE),
      getDataFollowKeyByDot(item, listColumn.REF_PRICE),
      getDataFollowKeyByDot(item, listColumn.HIGH_PRICE),
      getDataFollowKeyByDot(item, listColumn.LOW_PRICE),
      'text',
    );
  };

  handleScroll = e => {
    const { totalPage, loadMoreData, page, isLoading } = this.props;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (page === totalPage || isLoading) return;

    if (bottom) {
      const newpage = page + 1;
      loadMoreData(newpage);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.page === 1) {
      this.resetScroll();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { sortState, getScreenerData } = this.props;
    if (sortState !== prevProps.sortState) {
      getScreenerData(getSortStateParams(sortState));
    }
  }

  resetScroll = () => {
    this.tableRef.current.scrollToTop();
  };

  schema = (listColumn, i18nTitleKey) =>
    Object.keys(Const.listColumn).map((item, index) => {
      const key = listColumn[item];
      const title = `${i18nTitleKey}.${item}`;

      const result = {
        key,
        title,
      };

      if (index === 0) {
        return {
          ...result,
          isString: true,
          render: (text, item) => (
            <CellHover
              organCode={item.stockScreenerItem.organCode}
              isShowDeleteIcon={false}
            >
              <TextBlink item={item} tradingDate="tradingDate">
                <TradingViewUrl code={item.stockScreenerItem.organCode} />
                &nbsp;{text}
              </TextBlink>
            </CellHover>
          ),
        };
      }

      if (
        _.includes([listColumn.EBIT_MARGIN, listColumn.NET_PROFIT_GROWTH], key)
      ) {
        return {
          ...result,
          render: text => (
            <div className="pl-8 pr-8">{formatPercent(text)} %</div>
          ),
        };
      }

      if (_.includes([listColumn.PRICE], key)) {
        return {
          ...result,
          render: (text, item) => {
            const className = this.getClassName(item, listColumn);
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className={className}
              >
                {formatTextFloat(formatPrice(text), 2, true)}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.PERCENT_PRICE_CHANGE], key)) {
        return {
          ...result,
          render: (text, item) => {
            const className = this.getClassName(item, listColumn);
            const price = getDataFollowKeyByDot(item, listColumn.PRICE);
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className={className}
              >
                {price === 0 ? '--' : `${formatTextFloat(text * 100)}%`}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.ISA3], key)) {
        return {
          ...result,
          render: text => (
            <TextBlink item={item} tradingDate="tradingDate">
              {formatTextFloat(formatValueBillion(text))}
            </TextBlink>
          ),
        };
      }

      if (_.includes([listColumn.ISA20], key)) {
        return {
          ...result,
          render: text => (
            <TextBlink item={item} tradingDate="tradingDate">
              {cellNegtiveRed(formatValueBillion(text), 2)}
            </TextBlink>
          ),
        };
      }

      if (_.includes([listColumn.RTD14], key)) {
        return {
          ...result,
          render: text => (
            <TextBlink item={item} tradingDate="tradingDate">
              {cellNegtiveRed(formatTextFloat(text, 0))}
            </TextBlink>
          ),
        };
      }

      if (_.includes([listColumn.RTD7], key)) {
        return {
          ...result,
          render: text => (
            <TextBlink item={item} tradingDate="tradingDate">
              {formatTextFloat(text, 0)}
            </TextBlink>
          ),
        };
      }

      return {
        ...result,
        render: text => (
          <TextBlink item={item} tradingDate="tradingDate">
            {cellNegtiveRed(text)}
          </TextBlink>
        ),
      };
    });

  render() {
    const { isLoading, ids, sortState, changeSortState } = this.props;
    return (
      <RowClick>
        {onRowClick => (
          <Table
            clickRow={onRowClick}
            sortState={sortState}
            onSort={changeSortState}
            scrollRef={this.tableRef}
            thValign="top"
            ids={ids}
            isLoading={isLoading}
            resizable={true}
            columnDraggable={false}
            rowDraggable={false}
            onScrollFunction={this.handleScroll}
            hideColumns={Const.listHideColumn}
            getDataFromRedux={this.getDataFromRedux}
            schema={this.schema(
              Const.listColumn,
              'stockScreener.financialHeader',
            )}
          />
        )}
      </RowClick>
    );
  }
}

const mapStateToProps = state => {
  return {
    ids: state[REDUCER_NAME].listScreenerDataTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
    page: state[REDUCER_NAME].page,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
  loadMoreData,
  getScreenerData,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(TableFinancial);
